<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">OPÇÕES DE PRAZO</h3>
  </div>
  <div class="modal-body">
    <div
      class="button-row"
      [ngClass]="{
        even: isEven(opcoesPagamento),
        odd: !isEven(opcoesPagamento)
      }"
    >
      <button
        class="btn btn-full-orange"
        *ngFor="let opcoes of opcoesPagamento; let i = index"
        [ngClass]="{ focus: index === i }"
        [id]="opcoes.tabela.carencia"
        [value]="opcoes.tabela.carencia"
        (click)="onSelect(i)"
      >
        <div class="info">
          <span class="dias">{{ opcoes.tabela.carencia }} dias</span>
          <div *ngFor="let opcao of opcoes.opcoesParcelamento" class="opcoes">
            <span class="detail period">{{ opcao.period }}x</span>
            <span class="detail amount"
              ><b>{{ opcao.amount | currency: 'BRL' }}</b></span
            >
            <span class="detail interest">
              {{
                opcao.interest > 0
                  ? 'juros ' + opcao.interest + '% a.m.'
                  : 'sem juros'
              }}
            </span>
          </div>
        </div>
      </button>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="marginT30 form-group tab-buttons">
        <a class="bt-back btn btn-border-orange pull-left" (click)="close()">
          Fechar</a
        >
        <button
          type="button"
          class="bt-go btn btn-full-orange pull-right"
          (click)="save()"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
